import type { ReactNode } from "react";
import clsx from "clsx";

import { Card } from "./card";

export interface EmptyStateProps {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
  variant?: "card" | "inline";
}

export const EmptyState = ({
  title,
  description,
  action,
  className,
  variant = "card",
}: EmptyStateProps) => (
  <StateContainer
    variant={variant}
    className={clsx("border-dashed border-border-strong text-center", className)}
  >
    <h3
      className={clsx(
        "font-semibold text-content-primary",
        variant === "inline" ? "text-sm" : "text-lg",
      )}
    >
      {title}
    </h3>
    {description ? (
      <p className="mx-auto mt-2 max-w-lg text-sm text-content-muted">
        {description}
      </p>
    ) : null}
    {action ? <div className="mt-4">{action}</div> : null}
  </StateContainer>
);

const StateContainer = ({
  variant,
  className,
  children,
}: {
  variant: "card" | "inline";
  className?: string;
  children: ReactNode;
}) => {
  if (variant === "inline") {
    return (
      <div
        className={clsx(
          "rounded-control border bg-surface-secondary px-4 py-5",
          className,
        )}
      >
        {children}
      </div>
    );
  }

  return (
    <Card className={clsx("bg-surface-primary", className)}>
      {children}
    </Card>
  );
};

export default EmptyState;
